import { NgModule } from '@angular/core';

/**
 * directives
 */
import { TableContentRenderedDirective, TableSortableColumnDirective, TableTreeRowDirective } from './directives';
import { TemplateDirective } from '@sharedDirectives/templates/template.directive';

/**
 * components
 */
import {
  TableComponent,
  TreeTableComponent,
  TableSearchComponent,
  TableCheckboxComponent,
  TableSortIconComponent,
  TableTreeTogglerComponent,
  TableHeaderCheckboxComponent,
} from './components';


@NgModule({
  exports: [
    TableComponent,
    TemplateDirective,
    TableSortableColumnDirective,
    TableCheckboxComponent,
    TableHeaderCheckboxComponent,
    TableSearchComponent,
    TableSortIconComponent,
    TableContentRenderedDirective,
    TreeTableComponent,
    TableTreeRowDirective,
    TableTreeTogglerComponent,
  ],
  imports: [
    TableComponent,
    TemplateDirective,
    TableSortableColumnDirective,
    TableCheckboxComponent,
    TableHeaderCheckboxComponent,
    TableSearchComponent,
    TableSortIconComponent,
    TableContentRenderedDirective,
    TreeTableComponent,
    TableTreeRowDirective,
    TableTreeTogglerComponent,
  ]
})
export class TableModule {}